import React, { useState } from 'react';
import LegalDocModal from '@/components/LegalDocModal';

/**
 * Rodapé público de compliance / jurídico.
 *
 * Renderiza uma linha discreta com os 5 documentos legais (Termos do Cliente,
 * Termos do Prestador, Política de Privacidade, Política de Contestação e
 * Política de Reembolso). Cada link abre o `LegalDocModal` correspondente,
 * que busca a versão ATIVA do documento via `/api/admin/terms/active`.
 *
 * Usado em áreas públicas (Landing, Login/Cadastro, Checkout). NÃO usar em
 * dashboards internos.
 *
 * Props:
 *  - className?: classes extras (ex.: espaçamento, tema escuro)
 *  - tone?: 'light' (default, fundo claro) | 'dark' (fundo escuro)
 */
const LINKS = [
  { type: 'client', label: 'Termos do Cliente' },
  { type: 'provider', label: 'Termos do Prestador' },
  { type: 'privacy_policy', label: 'Privacidade' },
  { type: 'dispute_policy', label: 'Contestação' },
  { type: 'refund_policy', label: 'Reembolso' },
];

export default function PublicLegalFooter({ className = '', tone = 'light' }) {
  const [openType, setOpenType] = useState(null);

  const baseColor =
    tone === 'dark'
      ? 'text-slate-400 hover:text-white'
      : 'text-slate-500 hover:text-slate-800';
  const separatorColor = tone === 'dark' ? 'text-slate-600' : 'text-slate-300';

  return (
    <>
      <nav
        aria-label="Documentos legais"
        className={`w-full text-center text-[12px] leading-relaxed ${className}`}
        data-testid="public-legal-footer"
      >
        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
          {LINKS.map((link, idx) => (
            <React.Fragment key={link.type}>
              {idx > 0 && (
                <span className={separatorColor} aria-hidden="true">
                  •
                </span>
              )}
              <button
                type="button"
                onClick={() => setOpenType(link.type)}
                className={`${baseColor} underline-offset-2 hover:underline transition-colors`}
                data-testid={`public-legal-${link.type}-link`}
              >
                {link.label}
              </button>
            </React.Fragment>
          ))}
        </div>
      </nav>

      <LegalDocModal
        type={openType}
        open={openType !== null}
        onOpenChange={(o) => !o && setOpenType(null)}
        testIdPrefix="public-legal"
      />
    </>
  );
}
